import { EllipsisHorizontalIcon } from "@heroicons/react/24/outline";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuTrigger
} from "@moe/oss/ui/dropdown-menu";
import { OptionsModal } from "@web/components/OptionsModal";
import { Action } from "@web/route-services/chat/message/utils";
import { useAppContext } from "@web/route-services/root/AppContext";
import React from "react";

interface Props {
  actions: Action[];
}

export function OptionsButton({ actions }: Props) {
  const { createModal, isDesktopScreen } = useAppContext();

  const createOptionModal = () => {
    createModal({
      content: <OptionsModal actions={actions} />
    });
  };

  const EllipsisHorizontalIconClasses = `size-6 cursor-pointer 
    hover:text-button-highlight-hover
    active:text-action-tertiary
    transition duration-300 ease-out`;

  if (isDesktopScreen) {
    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <EllipsisHorizontalIcon className={EllipsisHorizontalIconClasses} />
        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-40">
          {actions.map((action, index) => (
            <React.Fragment key={action.label}>
              {index === 1 && <DropdownMenuSeparator />}
              <DropdownMenuGroup>
                {action.show !== false && (
                  <DropdownMenuItem onSelect={action.onClick}>
                    {action.label}
                    <DropdownMenuShortcut>
                      <action.icon className="size-4" />
                    </DropdownMenuShortcut>
                  </DropdownMenuItem>
                )}
              </DropdownMenuGroup>
            </React.Fragment>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    );
  }

  return (
    <div className="flex items-center">
      <button onClick={createOptionModal}>
        <EllipsisHorizontalIcon className={EllipsisHorizontalIconClasses} />
      </button>
    </div>
  );
}
